export const Role = {
    SystemAdmin: 'System Administrator',
    Admin: 'Administrator',
    User: 'User',
}
